// extracted by mini-css-extract-plugin
export default {"root":"partners_root__Li87o","logo":"partners_logo__XHRbg","image":"partners_image__6lD3D"};